import './hero-cards.scss';

/**
 * version    1.0
 * class      <type> (hero-cards)
 * classdesc  Component that manage the page hero cards
 */
export class HeroCards {}
